import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePriceComparison } from "@/contexts/classified";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { TrophyIcon } from "@gemini/icons";
import { useContext, useEffect, useRef, useState } from "react";
import { SliderRefContext } from "./PriceComparisonSlider";
export const PriceComparisonSliderMarker = ({ pricePerSqm, }) => {
    var _a;
    const { t } = useI18n();
    const [markerPosition, setMarkerPosition] = useState(0);
    const markerInPercent = (_a = usePriceComparison()) === null || _a === void 0 ? void 0 : _a.markerPosition;
    const markerRef = useRef(null);
    const sliderRef = useContext(SliderRefContext);
    useEffect(() => {
        const handleResize = () => {
            var _a, _b;
            const markerWidth = 
            // @ts-ignore
            ((_a = markerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) * (markerInPercent / 100);
            const sliderWidth = 
            // @ts-ignore
            ((_b = sliderRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) * (markerInPercent / 100);
            setMarkerPosition(sliderWidth - markerWidth);
        };
        handleResize();
        // eslint-disable-next-line no-restricted-globals
        window.addEventListener("resize", handleResize);
        return () => {
            // eslint-disable-next-line no-restricted-globals
            window.removeEventListener("resize", handleResize);
        };
    }, [sliderRef, markerInPercent]);
    if (typeof markerInPercent === "undefined")
        return null;
    const isLowerThanAverage = markerInPercent < 50;
    const priceText = isLowerThanAverage
        ? t("pricecomparison.price_is_lower_bic")
        : t("pricecomparison.this_listing");
    return (_jsxs(Box, { ref: markerRef, left: markerPosition, backgroundColor: isLowerThanAverage
            ? "#ECF8EB"
            : "color.surface.constant.black.default", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", borderRadius: "radius.8", width: "max-content", position: "relative", marginBottom: "spacing.16", padding: "spacing.12", borderWidth: isLowerThanAverage ? "borderWidth.1" : "borderWidth.none", borderColor: isLowerThanAverage ? "color.border.status.success.default" : "inherit", borderStyle: isLowerThanAverage ? "solid" : "none", children: [_jsxs(Box, { display: "flex", gap: "spacing.8", alignItems: "center", children: [isLowerThanAverage && (_jsx(Box, { as: "span", color: "color.border.status.success.default", children: _jsx(TrophyIcon, { size: "sizing.16" }) })), _jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Box, { color: isLowerThanAverage
                                    ? "color.border.status.success.default"
                                    : "color.background.constant.white", typography: "typography.body.12.regular", order: isLowerThanAverage ? "2" : "1", children: priceText }), _jsx(Box, { display: "flex", color: isLowerThanAverage
                                    ? "color.border.status.success.default"
                                    : "color.background.constant.white", typography: "typography.body.16.bold", order: isLowerThanAverage ? "1" : "2", children: `${pricePerSqm} €/m²` })] })] }), _jsx(Box, { position: "absolute", bottom: "-8px", color: isLowerThanAverage
                    ? "color.border.status.success.default"
                    : "color.surface.constant.black.default", left: isLowerThanAverage
                    ? markerPosition
                    : markerInPercent >= markerPosition
                        ? "0"
                        : `calc(100% - 24px)`, children: _jsx(Box, { as: "div", borderLeftColor: "color.border.constant.white", borderLeftStyle: "solid", unsafe_style: {
                        borderLeftWidth: "8px",
                        borderRightWidth: "8px",
                        borderTopWidth: "8px",
                    }, borderRightColor: "color.border.constant.white", borderRightStyle: "solid", borderTopColor: isLowerThanAverage
                        ? "color.border.status.success.default"
                        : "color.surface.constant.black.default", borderTopStyle: "solid" }) })] }));
};
